import { render, staticRenderFns } from "./BeaconCarriedListEditModal.vue?vue&type=template&id=6135f6b7&"
import script from "./BeaconCarriedListEditModal.vue?vue&type=script&lang=ts&"
export * from "./BeaconCarriedListEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports